/**
 * Sessions + Login history API (Doc 52).
 */
import { api } from "@/api/client";

export interface SessionItem {
  id: string;
  user_agent: string | null;
  ip_address: string | null;
  created_at: string;
  expires_at: string;
  revoked_at: string | null;
  is_current: boolean;
  is_active: boolean;
}

export interface SessionsListResponse {
  items: SessionItem[];
  current_session_id: string | null;
}

export interface AdminSessionItem {
  id: string;
  user_id: string;
  user_agent: string | null;
  ip_address: string | null;
  created_at: string;
  expires_at: string;
  revoked_at: string | null;
  is_active: boolean;
}

export interface LoginHistoryItem {
  id: string;
  action: string;
  target_model: string | null;
  target_id: string | null;
  ip_address: string | null;
  user_agent: string | null;
  after_state: Record<string, unknown> | null;
  created_at: string;
}

export const mySessionsApi = {
  list: (includeRevoked = false): Promise<SessionsListResponse> =>
    api.get<SessionsListResponse>("/api/v1/me/sessions", {
      query: { include_revoked: includeRevoked },
    }),
  revoke: (sessionId: string): Promise<void> =>
    api.delete<void>(`/api/v1/me/sessions/${sessionId}`),
};

export const adminSessionsApi = {
  listForUser: (userId: string, includeRevoked = true) =>
    api.get<{ items: AdminSessionItem[] }>(
      `/api/v1/admin/users/${userId}/sessions`,
      { query: { include_revoked: includeRevoked } },
    ),
  revoke: (userId: string, sessionId: string) =>
    api.delete<void>(
      `/api/v1/admin/users/${userId}/sessions/${sessionId}`,
    ),
  loginHistory: (userId: string, limit = 50) =>
    api.get<{ items: LoginHistoryItem[] }>(
      `/api/v1/admin/users/${userId}/login-history`,
      { query: { limit } },
    ),
};
